import { IBomPart } from 'bom/types';

import { IManageElementData, IManageElementsData } from './type';

export const mapManageElementsData = (data: IManageElementsData, bomPart: IBomPart) => {
  const elementNew = [];

  const removeFromElements = [];
  const updateElements = [];
  const addToElements = [];

  data.elements.forEach((elementData: IManageElementData) => {
    if (elementData.deleted) {
      removeFromElements.push({
        id: elementData.element.id,
      });
    } else if (elementData.isNew) {
      elementNew.push({
        [elementData.element.name]: elementData.element.name,
      });

      addToElements.push({
        id: elementData.element.id,
        quantity: elementData.quantityPerElement,
      });
    } else {
      updateElements.push({
        id: elementData.element.id,
        quantity: elementData.quantityPerElement,
      });
    }
  });

  return {
    ...(elementNew.length > 0 && { elementNew }),
    component: {
      bomId: bomPart.bomId,
    },
    bomPart: {
      bomId: bomPart.bomId,
      id: bomPart.id,
      part: bomPart.partArr?.number,
      componentId: bomPart.componentId,
      ...(removeFromElements.length > 0 && { removeFromElements }),
      ...(updateElements.length > 0 && { updateElements }),
      ...(addToElements.length > 0 && { addToElements }),
    },
  };
};
